export const t = {
  fr: {
    order: 'Commande',
    history: 'Historique',
    menu: 'Menu',
    stats: 'Statistiques',
    currentOrder: 'Commande en cours',
    confirmOrder: 'Confirmer la commande',
    total: 'Total',
    saving: 'Enregistrement...',
    online: '🟢 En ligne',
    offline: '🔴 Hors ligne',
    syncing: '🔄 Synchronisation...',
    orderSaved: '✅ Commande enregistrée!',
    savedLocally: '📱 Sauvegardé localement — sera synchronisé en ligne',
    all: 'Tout',
    hotDrinks: 'Boissons chaudes',
    coldDrinks: 'Boissons froides',
    food: 'Nourriture',
    loadingMenu: 'Chargement du menu...',
    runningLow: '⚠️ Stock faible',
    todayOrders: "Commandes du jour",
    todayRevenue: "Recettes du jour",
    totalOrders: 'Total commandes',
    orderHistory: 'Historique des commandes',
    noOrders: 'Pas encore de commandes. Commencez ! 🌅',
    loadingHistory: 'Chargement de l\'historique...',
    menuEditor: 'Éditeur de menu',
    addItem: '+ Ajouter un article',
    lowStock: '⚠️ Stock faible',
    name: 'Nom',
    price: 'Prix (MAD)',
    stockQty: 'Quantité en stock',
    category: 'Catégorie',
    cancel: 'Annuler',
    save: 'Enregistrer',
    editItem: 'Modifier l\'article',
    addNewItem: 'Ajouter un article',
    inStock: 'en stock',
    noItemsYet: 'Aucun article pour l\'instant',
    analytics: 'Analytiques',
    todayRevenueStat: "Recettes du jour",
    todayOrdersStat: "Commandes du jour",
    allTimeRevenue: 'Recettes totales',
    avgOrderValue: 'Valeur moy. commande',
    revenue: 'Recettes',
    days7: '7 jours',
    days30: '30 jours',
    bestSellers: '🏆 Meilleures ventes',
    sold: 'vendus',
    busiestHours: '🕐 Heures de pointe',
    loadingAnalytics: 'Chargement des statistiques...',
    pdfReport: '📄 Rapport PDF',
    currency: 'MAD',
    pending: 'en attente de sync',
    catHotDrinks: 'Boissons Chaudes',
    catColdDrinks: 'Boissons Froides',
    catFood: 'Nourriture',
    deleteOrder: 'Supprimer',
    deletedOrder: '🗑️ Supprimé',
    deleteReason: 'Raison (optionnel)',
    confirmDelete: 'Confirmer la suppression',
    cancelDelete: 'Annuler',
    showDeleted: 'Afficher supprimés',
    hideDeleted: 'Masquer supprimés',
    email: 'Email',
    emailOrPhone: 'Email ou téléphone',
    phoneNoReset: 'Compte par téléphone : demandez à votre responsable de réinitialiser le mot de passe.',
    password: 'Mot de passe',
    fullName: 'Nom complet',
    signIn: 'Se connecter',
    signUp: 'Créer un compte',
    noAccount: 'Pas de compte ? Créer un compte',
    haveAccount: 'Déjà un compte ? Se connecter',
    authError: 'Email ou mot de passe incorrect',
    signUpError: "Impossible de créer le compte",
    emailTaken: 'Un compte existe déjà avec cet email — connectez-vous.',
    forgotPassword: 'Mot de passe oublié ?',
    enterEmailFirst: "Entrez d'abord votre email ci-dessus, puis cliquez à nouveau.",
    resetEmailSent: '📧 Email envoyé ! Cliquez sur le lien reçu pour choisir un nouveau mot de passe.',
    chooseNewPassword: 'Choisissez un nouveau mot de passe',
    newPassword: 'Nouveau mot de passe',
    tooManyEmails: "Trop d'emails envoyés — patientez une heure puis réessayez.",
    resetError: "Impossible d'envoyer l'email de réinitialisation. Réessayez plus tard.",
    checkEmail: '📧 Compte créé ! Vérifiez votre email pour confirmer.',
    passwordShort: 'Le mot de passe doit contenir au moins 8 caractères',
    onboardTitle: 'Bienvenue !',
    onboardSub: 'Créez votre café ou rejoignez une équipe',
    createShop: 'Créer mon café',
    shopName: 'Nom du café',
    joinTeam: 'Rejoindre une équipe',
    joinCode: "Code d'équipe",
    create: 'Créer',
    join: 'Rejoindre',
    invalidCode: 'Code invalide',
    settings: 'Réglages',
    team: 'Équipe',
    roleOwner: 'Propriétaire',
    roleManager: 'Gérant',
    roleCashier: 'Caissier',
    joinCodeHint: "Partagez ce code avec votre personnel pour qu'il rejoigne votre café",
    joinHint: "Vous rejoignez une équipe ? Créez d'abord votre compte — vous entrerez le code juste après.",
    removeMember: 'Retirer',
    removeConfirm: "Retirer {name} de l'équipe ? Cette personne perdra l'accès à ce café.",
    removeError: "Impossible de retirer ce membre",
    reservations: 'Réservations',
    newReservation: 'Nouvelle location',
    editReservation: 'Modifier la location',
    totalBooked: 'Total réservé',
    depositsReceived: 'Avances reçues',
    toCollect: 'Reste à encaisser',
    eventDate: "Date de l'événement",
    clientName: 'Nom du client',
    clientPhone: 'Téléphone (optionnel)',
    rentalPrice: 'Prix de location',
    deposit: 'Avance',
    remaining: 'Reste à payer',
    statusLabel: 'Statut',
    statusReserved: 'Réservé',
    statusDone: 'Terminé',
    statusCancelled: 'Annulé',
    resvNotes: 'Notes',
    resvMissing: 'Ajoutez au moins la date et le nom du client',
    resvDepositTooHigh: "L'avance ne peut pas dépasser le prix",
    resvDayTaken: 'Ce jour est déjà réservé pour {client}. Continuer quand même ?',
    resvDeleteConfirm: 'Supprimer cette réservation ?',
    resvDelete: 'Supprimer',
    resvReceiptTitle: 'Reçu de réservation',
    receiptResv: 'Reçu',
    noReservations: 'Aucune réservation pour le moment. Ajoutez la première 🌅',
    branchTypeTitle: 'Type de cette branche',
    branchTypeCafe: 'Café (caisse)',
    branchTypeEvents: 'Salle des fêtes (réservations)',
    branchTypeHint: 'Choisissez « Salle des fêtes » pour une salle de mariage : cette branche affichera les réservations au lieu de la caisse.',
    receipt: 'Reçu', receiptThanks: 'Merci et à bientôt ! 🌅', sendReceipt: 'Envoyer le reçu (WhatsApp)', joinInvite: 'Rejoins l\'équipe de {shop} sur StratosPOS 🌅 — crée un compte ici :',
    shopInfo: 'Mon café',
    loadingApp: 'Chargement...',
    categoriesTitle: 'Catégories de produits',
    newCategory: 'Nouvelle catégorie',
    add: 'Ajouter',
    categoriesHint: 'Chaque boutique peut définir ses propres catégories (ex: Grains de café, Filtres...)',
    myAccount: 'Mon compte',
    yourName: 'Votre nom',
    newPasswordOptional: 'Nouveau mot de passe (optionnel)',
    accountSaved: '✅ Enregistré',
    logout: 'Se déconnecter',
    logoutConfirm: 'Se déconnecter ? Vous devrez ressaisir votre mot de passe.',
    orderType: 'Type de commande', dineIn: 'Sur place', takeaway: 'À emporter', table: 'Table', tableNumber: 'N° de table',
    paymentMethod: 'Paiement', payCash: 'Espèces', payCard: 'Carte', payCarnet: 'Carnet',
    orderFailed: '❌ Enregistrement échoué. Réessayez.',
    costLabel: 'Prix de revient (coût)', marginLabel: 'Marge', todayProfit: 'Bénéfice du jour', totalProfit: 'Bénéfice total', byCashier: 'Ventes par caissier',
    branchesTitle: 'Succursales', newBranch: 'Nom de la nouvelle succursale', branchCreated: '✅ Succursale créée !', branchLimit: 'Limite de 5 succursales atteinte.', goToBranch: 'Ouvrir', branchHint: 'Chaque succursale a son propre menu, ses commandes et son équipe. Changez de succursale depuis la barre du haut.', groupView: 'Toutes les succursales', todayShort: "Aujourd'hui", thisMonth: 'Ce mois', exportCsv: '⬇️ Export CSV', dataBackup: 'Données & sauvegarde', dataBackupHint: 'Téléchargez une copie complète de vos données (produits, ventes, carnet) à conserver en lieu sûr. Vos données vous appartiennent.', exportBackup: 'Exporter mes données', privacyPolicy: 'Politique de confidentialité', termsOfService: "Conditions d'utilisation",
    profitHint: '💡 Ajoutez le coût de vos produits (dans Menu) pour voir votre bénéfice réel, pas seulement les recettes.',
    dayClose: 'Caisse du soir', cashCount: 'Comptage de caisse', cashCountHint: 'Comptez les espèces dans la caisse et saisissez le montant pour vérifier.',
    expectedCash: 'Espèces attendues', countedCash: 'Espèces comptées', difference: 'Écart', over: 'surplus', short: 'manque',
    carnet: 'Carnet', addCustomer: 'Nouveau client', totalOwed: 'Total dû', noCustomers: 'Aucun client pour le moment.', settled: 'Réglé',
    paymentAmount: 'Montant', recordPayment: 'Encaisser', carnetOrders: 'commandes', carnetPayments: 'paiements',
    customerName: 'Nom du client', customerPhone: 'Téléphone (optionnel)', chooseCustomer: 'Choisir un client', orNewCustomer: 'ou nom d\'un nouveau client',
    subExpired: 'Abonnement expiré',
    subExpiredMsg: 'Votre abonnement a expiré. Contactez-nous pour le renouveler et retrouver votre boutique.',
    subWarning: 'Votre abonnement expire dans {days} jour(s) — pensez à renouveler',
    paidUntil: 'Abonnement jusqu\'au',
    importMenu: '📷 Importer un menu',
    importAnalyzing: '✨ Analyse du menu...',
    importDetected: 'Produits détectés',
    importAddAll: 'Ajouter {n} produits',
    importError: "Impossible de lire ce fichier. Essayez une photo plus nette ou ajoutez les produits manuellement.",
    importNoItems: 'Aucun produit trouvé sur cette image.',
    importSoon: '✨ Import par photo — bientôt disponible ! Pour l\'instant, ajoutez vos produits avec « + Ajouter un article ».',
    planLabel: 'Formule',
    planBasic: 'Basic',
    planPro: 'Pro ⭐',
    planMax: 'Max 👑',
    proOnly: 'Fonctionnalité Pro',
    proOnlyMsg: 'Les statistiques et les rapports PDF font partie de la formule Pro. Contactez-nous pour améliorer votre formule.',
    staffLimit: 'Limite de 2 comptes atteinte (formule Basic). Passez à Pro pour une équipe illimitée.',
  },
  en: {
    order: 'Order',
    history: 'History',
    menu: 'Menu',
    stats: 'Stats',
    currentOrder: 'Current Order',
    confirmOrder: 'Confirm Order',
    total: 'Total',
    saving: 'Saving...',
    online: '🟢 Online',
    offline: '🔴 Offline',
    syncing: '🔄 Syncing...',
    orderSaved: '✅ Order saved!',
    savedLocally: '📱 Saved locally — will sync when online',
    all: 'All',
    hotDrinks: 'Hot Drinks',
    coldDrinks: 'Cold Drinks',
    food: 'Food',
    loadingMenu: 'Loading menu...',
    runningLow: '⚠️ Running low',
    todayOrders: "Today's Orders",
    todayRevenue: "Today's Revenue",
    totalOrders: 'Total Orders',
    orderHistory: 'Order History',
    noOrders: 'No orders yet. Start taking orders! 🌅',
    loadingHistory: 'Loading history...',
    menuEditor: 'Menu Editor',
    addItem: '+ Add Item',
    lowStock: '⚠️ Low stock',
    name: 'Name',
    price: 'Price (MAD)',
    stockQty: 'Stock quantity',
    category: 'Category',
    cancel: 'Cancel',
    save: 'Save',
    editItem: 'Edit Item',
    addNewItem: 'Add New Item',
    inStock: 'in stock',
    noItemsYet: 'No items yet',
    analytics: 'Analytics',
    todayRevenueStat: "Today's Revenue",
    todayOrdersStat: "Today's Orders",
    allTimeRevenue: 'All Time Revenue',
    avgOrderValue: 'Avg Order Value',
    revenue: 'Revenue',
    days7: '7 days',
    days30: '30 days',
    bestSellers: '🏆 Best Sellers',
    sold: 'sold',
    busiestHours: '🕐 Busiest Hours',
    loadingAnalytics: 'Loading analytics...',
    pdfReport: '📄 PDF Report',
    currency: 'MAD',
    pending: 'pending sync',
    catHotDrinks: 'Hot Drinks',
    catColdDrinks: 'Cold Drinks',
    catFood: 'Food',
    deleteOrder: 'Delete',
    deletedOrder: '🗑️ Deleted',
    deleteReason: 'Reason (optional)',
    confirmDelete: 'Confirm delete',
    cancelDelete: 'Cancel',
    showDeleted: 'Show deleted',
    hideDeleted: 'Hide deleted',
    email: 'Email',
    emailOrPhone: 'Email or phone',
    phoneNoReset: 'Phone account: ask your manager to reset your password.',
    password: 'Password',
    fullName: 'Full name',
    signIn: 'Sign in',
    signUp: 'Create account',
    noAccount: "No account? Create one",
    haveAccount: 'Already have an account? Sign in',
    authError: 'Incorrect email or password',
    signUpError: 'Could not create the account',
    emailTaken: 'An account already exists with this email — sign in instead.',
    forgotPassword: 'Forgot password?',
    enterEmailFirst: 'Enter your email above first, then click again.',
    resetEmailSent: '📧 Email sent! Click the link you received to choose a new password.',
    chooseNewPassword: 'Choose a new password',
    newPassword: 'New password',
    tooManyEmails: 'Too many emails sent — wait an hour and try again.',
    resetError: "Couldn't send the reset email. Try again later.",
    checkEmail: '📧 Account created! Check your email to confirm.',
    passwordShort: 'Password must be at least 8 characters',
    onboardTitle: 'Welcome!',
    onboardSub: 'Create your café or join a team',
    createShop: 'Create my café',
    shopName: 'Café name',
    joinTeam: 'Join a team',
    joinCode: 'Team code',
    create: 'Create',
    join: 'Join',
    invalidCode: 'Invalid code',
    settings: 'Settings',
    team: 'Team',
    roleOwner: 'Owner',
    roleManager: 'Manager',
    roleCashier: 'Cashier',
    joinCodeHint: 'Share this code with your staff so they can join your café',
    joinHint: 'Joining a team? Create your account first — you\'ll enter the code right after.',
    removeMember: 'Remove',
    removeConfirm: 'Remove {name} from the team? They will lose access to this café.',
    removeError: 'Could not remove this member',
    reservations: 'Bookings',
    newReservation: 'New booking',
    editReservation: 'Edit booking',
    totalBooked: 'Total booked',
    depositsReceived: 'Deposits received',
    toCollect: 'Left to collect',
    eventDate: 'Event date',
    clientName: 'Client name',
    clientPhone: 'Phone (optional)',
    rentalPrice: 'Rental price',
    deposit: 'Deposit',
    remaining: 'Remaining',
    statusLabel: 'Status',
    statusReserved: 'Booked',
    statusDone: 'Done',
    statusCancelled: 'Cancelled',
    resvNotes: 'Notes',
    resvMissing: 'Add at least the date and the client name',
    resvDepositTooHigh: 'The deposit cannot exceed the price',
    resvDayTaken: 'This day is already booked for {client}. Continue anyway?',
    resvDeleteConfirm: 'Delete this booking?',
    resvDelete: 'Delete',
    resvReceiptTitle: 'Booking receipt',
    receiptResv: 'Receipt',
    noReservations: 'No bookings yet. Add the first one 🌅',
    branchTypeTitle: 'Type of this branch',
    branchTypeCafe: 'Café (POS)',
    branchTypeEvents: 'Events hall (bookings)',
    branchTypeHint: 'Choose "Events hall" for a wedding venue: this branch shows bookings instead of the POS.',
    receipt: 'Receipt', receiptThanks: 'Thank you, see you soon! 🌅', sendReceipt: 'Send receipt (WhatsApp)', joinInvite: 'Join {shop} on StratosPOS 🌅 — create an account here:',
    shopInfo: 'My café',
    loadingApp: 'Loading...',
    categoriesTitle: 'Product categories',
    newCategory: 'New category',
    add: 'Add',
    categoriesHint: 'Each shop can define its own categories (e.g. Coffee Beans, Filters...)',
    myAccount: 'My account',
    yourName: 'Your name',
    newPasswordOptional: 'New password (optional)',
    accountSaved: '✅ Saved',
    logout: 'Log out',
    logoutConfirm: 'Log out? You will need to enter your password again.',
    orderType: 'Order type', dineIn: 'Dine-in', takeaway: 'Takeaway', table: 'Table', tableNumber: 'Table number',
    paymentMethod: 'Payment', payCash: 'Cash', payCard: 'Card', payCarnet: 'Tab',
    orderFailed: '❌ Could not save the order. Try again.',
    costLabel: 'Cost price', marginLabel: 'Margin', todayProfit: "Today's Profit", totalProfit: 'Total Profit', byCashier: 'Sales by cashier',
    branchesTitle: 'Branches', newBranch: 'New branch name', branchCreated: '✅ Branch created!', branchLimit: '5-branch limit reached.', goToBranch: 'Open', branchHint: 'Each branch has its own menu, orders and team. Switch branches from the top bar.', groupView: 'All branches', todayShort: 'Today', thisMonth: 'This month', exportCsv: '⬇️ CSV Export', dataBackup: 'Data & backup', dataBackupHint: 'Download a full copy of your data (products, sales, tabs) to keep somewhere safe. Your data is yours.', exportBackup: 'Export my data', privacyPolicy: 'Privacy Policy', termsOfService: 'Terms of Service',
    profitHint: '💡 Add your products cost (in Menu) to see your real profit, not just revenue.',
    dayClose: 'Day Close', cashCount: 'Cash count', cashCountHint: 'Count the cash in the drawer and enter it to check.',
    expectedCash: 'Expected cash', countedCash: 'Counted cash', difference: 'Difference', over: 'over', short: 'short',
    carnet: 'Tab', addCustomer: 'New customer', totalOwed: 'Total owed', noCustomers: 'No customers yet.', settled: 'Settled',
    paymentAmount: 'Amount', recordPayment: 'Record', carnetOrders: 'orders', carnetPayments: 'payments',
    customerName: 'Customer name', customerPhone: 'Phone (optional)', chooseCustomer: 'Choose a customer', orNewCustomer: 'or new customer name',
    subExpired: 'Subscription expired',
    subExpiredMsg: 'Your subscription has expired. Contact us to renew and get your shop back.',
    subWarning: 'Your subscription expires in {days} day(s) — remember to renew',
    paidUntil: 'Subscribed until',
    importMenu: '📷 Import a menu',
    importAnalyzing: '✨ Reading the menu...',
    importDetected: 'Detected products',
    importAddAll: 'Add {n} products',
    importError: "Couldn't read this file. Try a sharper photo, or add products manually.",
    importNoItems: 'No products found in this image.',
    importSoon: '✨ Photo import — coming soon! For now, add your products with "+ Add Item".',
    planLabel: 'Plan',
    planBasic: 'Basic',
    planPro: 'Pro ⭐',
    planMax: 'Max 👑',
    proOnly: 'Pro feature',
    proOnlyMsg: 'Analytics and PDF reports are part of the Pro plan. Contact us to upgrade.',
    staffLimit: '2-account limit reached (Basic plan). Upgrade to Pro for unlimited staff.',
  },
  ar: {
    order: 'طلب',
    history: 'السجل',
    menu: 'القائمة',
    stats: 'إحصاء',
    currentOrder: 'الطلب الحالي',
    confirmOrder: 'تأكيد الطلب',
    total: 'المجموع',
    saving: 'جاري الحفظ...',
    online: '🟢 متصل',
    offline: '🔴 غير متصل',
    syncing: '🔄 جاري المزامنة...',
    orderSaved: '✅ تم حفظ الطلب!',
    savedLocally: '📱 محفوظ محلياً — سيتم المزامنة عند الاتصال',
    all: 'الكل',
    hotDrinks: 'مشروبات ساخنة',
    coldDrinks: 'مشروبات باردة',
    food: 'طعام',
    loadingMenu: 'جاري تحميل القائمة...',
    runningLow: '⚠️ مخزون منخفض',
    todayOrders: 'طلبات اليوم',
    todayRevenue: 'إيرادات اليوم',
    totalOrders: 'إجمالي الطلبات',
    orderHistory: 'سجل الطلبات',
    noOrders: 'لا توجد طلبات بعد. ابدأ في استقبال الطلبات! 🌅',
    loadingHistory: 'جاري تحميل السجل...',
    menuEditor: 'تعديل القائمة',
    addItem: '+ إضافة منتج',
    lowStock: '⚠️ مخزون منخفض',
    name: 'الاسم',
    price: 'السعر (درهم)',
    stockQty: 'الكمية في المخزون',
    category: 'الفئة',
    cancel: 'إلغاء',
    save: 'حفظ',
    editItem: 'تعديل المنتج',
    addNewItem: 'إضافة منتج جديد',
    inStock: 'متبقي',
    noItemsYet: 'لا توجد منتجات بعد',
    analytics: 'الإحصاءات',
    todayRevenueStat: 'إيرادات اليوم',
    todayOrdersStat: 'طلبات اليوم',
    allTimeRevenue: 'إجمالي الإيرادات',
    avgOrderValue: 'متوسط قيمة الطلب',
    revenue: 'الإيرادات',
    days7: '٧ أيام',
    days30: '٣٠ يوم',
    bestSellers: '🏆 الأكثر مبيعاً',
    sold: 'مباع',
    busiestHours: '🕐 أوقات الذروة',
    loadingAnalytics: 'جاري تحميل الإحصاءات...',
    pdfReport: '📄 تقرير PDF',
    currency: 'درهم',
    pending: 'في انتظار المزامنة',
    catHotDrinks: 'مشروبات ساخنة',
    catColdDrinks: 'مشروبات باردة',
    catFood: 'طعام',
    deleteOrder: 'حذف',
    deletedOrder: '🗑️ محذوف',
    deleteReason: 'السبب (اختياري)',
    confirmDelete: 'تأكيد الحذف',
    cancelDelete: 'إلغاء',
    showDeleted: 'عرض المحذوفات',
    hideDeleted: 'إخفاء المحذوفات',
    email: 'البريد الإلكتروني',
    emailOrPhone: 'البريد أو الهاتف',
    phoneNoReset: 'حساب بالهاتف: اطلب من مديرك إعادة تعيين كلمة المرور.',
    password: 'كلمة المرور',
    fullName: 'الاسم الكامل',
    signIn: 'تسجيل الدخول',
    signUp: 'إنشاء حساب',
    noAccount: 'ليس لديك حساب؟ أنشئ حساباً',
    haveAccount: 'لديك حساب؟ سجّل الدخول',
    authError: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
    signUpError: 'تعذر إنشاء الحساب',
    emailTaken: 'يوجد حساب بهذا البريد الإلكتروني بالفعل — سجّل الدخول.',
    forgotPassword: 'نسيت كلمة المرور؟',
    enterEmailFirst: 'أدخل بريدك الإلكتروني أعلاه أولاً ثم اضغط مرة أخرى.',
    resetEmailSent: '📧 تم إرسال البريد! اضغط على الرابط لاختيار كلمة مرور جديدة.',
    chooseNewPassword: 'اختر كلمة مرور جديدة',
    newPassword: 'كلمة مرور جديدة',
    tooManyEmails: 'تم إرسال الكثير من الرسائل — انتظر ساعة ثم حاول مجدداً.',
    resetError: 'تعذر إرسال بريد إعادة التعيين. حاول لاحقاً.',
    checkEmail: '📧 تم إنشاء الحساب! تحقق من بريدك الإلكتروني للتأكيد.',
    passwordShort: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
    onboardTitle: 'مرحباً!',
    onboardSub: 'أنشئ مقهاك أو انضم إلى فريق',
    createShop: 'إنشاء مقهاي',
    shopName: 'اسم المقهى',
    joinTeam: 'الانضمام إلى فريق',
    joinCode: 'رمز الفريق',
    create: 'إنشاء',
    join: 'انضمام',
    invalidCode: 'رمز غير صالح',
    settings: 'الإعدادات',
    team: 'الفريق',
    roleOwner: 'المالك',
    roleManager: 'المدير',
    roleCashier: 'أمين الصندوق',
    joinCodeHint: 'شارك هذا الرمز مع موظفيك للانضمام إلى مقهاك',
    joinHint: 'هل تنضم إلى فريق؟ أنشئ حسابك أولاً — ستُدخل الرمز مباشرة بعد ذلك.',
    removeMember: 'إزالة',
    removeConfirm: 'إزالة {name} من الفريق؟ سيفقد الوصول إلى هذا المقهى.',
    removeError: 'تعذّر إزالة هذا العضو',
    reservations: 'الحجوزات',
    newReservation: 'حجز جديد',
    editReservation: 'تعديل الحجز',
    totalBooked: 'إجمالي المحجوز',
    depositsReceived: 'التسبيقات المستلمة',
    toCollect: 'المتبقّي للتحصيل',
    eventDate: 'تاريخ المناسبة',
    clientName: 'اسم الزبون',
    clientPhone: 'الهاتف (اختياري)',
    rentalPrice: 'ثمن الكراء',
    deposit: 'التسبيق',
    remaining: 'المتبقّي',
    statusLabel: 'الحالة',
    statusReserved: 'محجوز',
    statusDone: 'منتهٍ',
    statusCancelled: 'ملغى',
    resvNotes: 'ملاحظات',
    resvMissing: 'أضف على الأقل التاريخ واسم الزبون',
    resvDepositTooHigh: 'لا يمكن أن يتجاوز التسبيق الثمن',
    resvDayTaken: 'هذا اليوم محجوز بالفعل لـ {client}. المتابعة؟',
    resvDeleteConfirm: 'حذف هذا الحجز؟',
    resvDelete: 'حذف',
    resvReceiptTitle: 'وصل الحجز',
    receiptResv: 'وصل',
    noReservations: 'لا توجد حجوزات بعد. أضف الأول 🌅',
    branchTypeTitle: 'نوع هذا الفرع',
    branchTypeCafe: 'مقهى (صندوق)',
    branchTypeEvents: 'قاعة حفلات (حجوزات)',
    branchTypeHint: 'اختر «قاعة حفلات» لقاعة الأعراس: سيعرض هذا الفرع الحجوزات بدل الصندوق.',
    receipt: 'إيصال', receiptThanks: 'شكراً ونراكم قريباً! 🌅', sendReceipt: 'إرسال الإيصال (واتساب)', joinInvite: 'انضم إلى {shop} على StratosPOS 🌅 — أنشئ حساباً هنا:',
    shopInfo: 'مقهاي',
    loadingApp: 'جاري التحميل...',
    categoriesTitle: 'فئات المنتجات',
    newCategory: 'فئة جديدة',
    add: 'إضافة',
    categoriesHint: 'يمكن لكل متجر تحديد فئاته الخاصة (مثل: حبوب القهوة، فلاتر...)',
    myAccount: 'حسابي',
    yourName: 'اسمك',
    newPasswordOptional: 'كلمة مرور جديدة (اختياري)',
    accountSaved: '✅ تم الحفظ',
    logout: 'تسجيل الخروج',
    logoutConfirm: 'تسجيل الخروج؟ ستحتاج إلى إدخال كلمة المرور مرة أخرى.',
    orderType: 'نوع الطلب', dineIn: 'في المكان', takeaway: 'للأخذ', table: 'طاولة', tableNumber: 'رقم الطاولة',
    paymentMethod: 'الدفع', payCash: 'نقداً', payCard: 'بطاقة', payCarnet: 'دفتر',
    orderFailed: '❌ تعذر حفظ الطلب. حاول مجدداً.',
    costLabel: 'سعر التكلفة', marginLabel: 'الهامش', todayProfit: 'ربح اليوم', totalProfit: 'إجمالي الربح', byCashier: 'المبيعات حسب الكاشير',
    branchesTitle: 'الفروع', newBranch: 'اسم الفرع الجديد', branchCreated: '✅ تم إنشاء الفرع!', branchLimit: 'تم بلوغ حد 5 فروع.', goToBranch: 'فتح', branchHint: 'لكل فرع قائمته وطلباته وفريقه الخاص. بدّل الفروع من الشريط العلوي.', groupView: 'جميع الفروع', todayShort: 'اليوم', thisMonth: 'هذا الشهر', exportCsv: '⬇️ تصدير CSV', dataBackup: 'البيانات والنسخ الاحتياطي', dataBackupHint: 'حمّل نسخة كاملة من بياناتك (المنتجات، المبيعات، الدفتر) واحتفظ بها في مكان آمن. بياناتك ملكك.', exportBackup: 'تصدير بياناتي', privacyPolicy: 'سياسة الخصوصية', termsOfService: 'شروط الاستخدام',
    profitHint: '💡 أضف تكلفة منتجاتك (في القائمة) لرؤية ربحك الحقيقي وليس الإيرادات فقط.',
    dayClose: 'إغلاق اليوم', cashCount: 'جرد الصندوق', cashCountHint: 'احسب النقود في الصندوق وأدخل المبلغ للتحقق.',
    expectedCash: 'النقد المتوقع', countedCash: 'النقد المحسوب', difference: 'الفرق', over: 'زيادة', short: 'نقص',
    carnet: 'الدفتر', addCustomer: 'عميل جديد', totalOwed: 'إجمالي المستحق', noCustomers: 'لا يوجد عملاء بعد.', settled: 'مسدد',
    paymentAmount: 'المبلغ', recordPayment: 'تحصيل', carnetOrders: 'طلبات', carnetPayments: 'دفعات',
    customerName: 'اسم العميل', customerPhone: 'الهاتف (اختياري)', chooseCustomer: 'اختر عميلاً', orNewCustomer: 'أو اسم عميل جديد',
    subExpired: 'انتهى الاشتراك',
    subExpiredMsg: 'انتهى اشتراكك. تواصل معنا لتجديده واستعادة متجرك.',
    subWarning: 'ينتهي اشتراكك خلال {days} يوم — لا تنسَ التجديد',
    paidUntil: 'الاشتراك حتى',
    importMenu: '📷 استيراد قائمة',
    importAnalyzing: '✨ جاري قراءة القائمة...',
    importDetected: 'المنتجات المكتشفة',
    importAddAll: 'إضافة {n} منتجات',
    importError: 'تعذرت قراءة هذا الملف. جرّب صورة أوضح أو أضف المنتجات يدوياً.',
    importNoItems: 'لم يتم العثور على منتجات في هذه الصورة.',
    importSoon: '✨ استيراد بالصورة — قريباً! في الوقت الحالي، أضف منتجاتك عبر «+ إضافة منتج».',
    planLabel: 'الباقة',
    planBasic: 'أساسية',
    planPro: 'برو ⭐',
    planMax: 'ماكس 👑',
    proOnly: 'ميزة برو',
    proOnlyMsg: 'الإحصاءات وتقارير PDF جزء من باقة برو. تواصل معنا للترقية.',
    staffLimit: 'تم بلوغ حد الحسابين (الباقة الأساسية). قم بالترقية إلى برو لفريق غير محدود.',
  }
};